import { BrowserRouter } from "react-router-dom";
import { RootRouter } from "containers/root-router";
import { MySnackbar } from "components/atoms/MySnackbar";
import { Palette } from "components/molecules/Palette";
import { ProfileMenu } from "components/molecules/ProfileMenu";
import { TrackMenu } from "components/molecules/TrackMenu";
import { RegionMenu } from "components/molecules/RegionMenu";
import { AddToPlaylistMenu } from "components/molecules/AddToPlaylistMenu";
import { CreatePlaylistMenu } from "components/molecules/CreatePlaylistMenu";
import { PlaylistMenu } from "components/molecules/PlaylistMenu";
import { PlaylistRemoveConfirmationMenu } from "components/molecules/PlaylistRemoveConfirmationMenu";
import { EditPlaylistMenu } from "components/molecules/EditPlaylistMenu";
import { EditUserFullNameMenu } from "components/molecules/EditUserFullNameMenu";
import { EditUserUserNameMenu } from "components/molecules/EditUserUserNameMenu";
import { EditUserEmailMenu } from "components/molecules/EditUserEmailMenu";
import { EditUserPhoneMenu } from "components/molecules/EditUserPhoneMenu";
import { EditUserPasswordMenu } from "components/molecules/EditUserPasswordMenu";
import { LogoutConfirmationMenu } from "components/molecules/LogoutConfirmationMenu";
import { DeleteAccountConfirmationMenu } from "components/molecules/DeleteAccountConfirmationMenu";
import { UserMenu } from "components/molecules/UserMenu";
import { ReportUserMenu } from "components/molecules/ReportUserMenu";
import { ReportUserDoneMenu } from "components/molecules/ReportUserDoneMenu";
import { ChatMenu } from "components/molecules/ChatMenu";
import {InstallPromptMenu} from "./components/molecules/InstallPromptMenu";
import {DownloadApplicationMenu} from "./components/molecules/DownloadApplicationMenu";
import {EditUserGenderMenu} from "./components/molecules/EditUserGenderMenu";

const App = () => {
  return (
    <BrowserRouter>
        <RootRouter />
        <MySnackbar />
        <Palette />
        <RegionMenu />
        <AddToPlaylistMenu />
        <CreatePlaylistMenu />
        <ProfileMenu />
        <InstallPromptMenu />
        <DownloadApplicationMenu />
        <TrackMenu />
        <PlaylistMenu />
        <PlaylistRemoveConfirmationMenu />
        <EditPlaylistMenu />
        <EditUserFullNameMenu />
        <EditUserGenderMenu />
        <EditUserUserNameMenu />
        <EditUserEmailMenu />
        <EditUserPhoneMenu />
        <EditUserPasswordMenu />
        <LogoutConfirmationMenu />
        <DeleteAccountConfirmationMenu />
        <UserMenu />
        <ReportUserMenu />
        <ReportUserDoneMenu />
        <ChatMenu />
    </BrowserRouter>
  )
}

export default App